import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="shell">
      <div className="card">
        <h1>Página não encontrada</h1>
        <p className="sub">
          O endereço acessado não existe nesta plataforma. Se você chegou aqui pela leitura de uma
          plaqueta, verifique se a válvula já teve o passaporte publicado.
        </p>
        <div className="sect">Ir para</div>
        <div className="rowitem">
          <Link to="/">Status da plataforma</Link>
          <span className="badge info">→</span>
        </div>
      </div>
    </div>
  );
}
